// extracted by mini-css-extract-plugin
module.exports = {"cartMiniWrapper":"CartMini_cartMiniWrapper__IEshs","icon":"CartMini_icon__KyfHZ"};